import { Box, Container } from '@mui/material';
import { DELETE_GROUP, LIST_GROUPS, CREATE_GROUP, UPDATE_GROUP } from "../../../graphql/admin-requests";
import React, { useState } from 'react';
import GroupListResults from './GroupListResults';
import EntityListToolbar from '../subcomponents/EntityListToolbar';
import { useEntityList } from '../../../hooks/useEntityList';
import CUSimpleItem from "../CreateUpdateComponents/SimpleItem";
import GroupCalendar from '../CalendarList/GroupCalendar';


function GroupList({ period }) {

    const [group, setGroup] = useState("");

    const {
        items: groups,
        totalCount,
        limit,
        setLimit,
        offset,
        setOffset,
        updateSearch,
        loadData,
        handleDelete: handleDeleteGroup,
    } = useEntityList({
        listQuery: LIST_GROUPS,
        listDataKey: "allGroups",
        deleteMutation: DELETE_GROUP,
        deleteVariableName: "groupUid",
        deleteErrorMessage: "Impossible de supprimer le groupe",
        deleteSuccessMessage: "Groupe supprimé",
    });

    return (group.uid) ?
        <GroupCalendar group={group} handleClose={() => setGroup({})} period={period} /> : (
            <Container component="main">
                <Box sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}>
                    <Container maxWidth={false}>
                        <EntityListToolbar
                            loadData={loadData}
                            updateSearch={updateSearch}
                            searchPlaceholder="Rechercher un groupe"
                            CreateComponent={CUSimpleItem}
                            createComponentProps={{ createRequest: CREATE_GROUP, updateRequest: UPDATE_GROUP, itemName: "groupe" }}
                        />
                        <Box sx={{ pt: 3 }}>
                            <GroupListResults
                                viewGroupCalendar={setGroup}
                                groups={groups}
                                loadData={loadData}
                                limit={limit}
                                offset={offset}
                                totalCount={totalCount}
                                setLimit={setLimit}
                                setOffset={setOffset}
                                handleDeleteGroup={handleDeleteGroup} />
                        </Box>
                    </Container>
                </Box>
            </Container >
        )
};

export default GroupList;
